import { Box, Image } from "@chakra-ui/react";
import { SlideVideo } from "components/SlideVideo";
import React from "react";
import api from "services/api";
import { StorageGetItem, StorageSetItem } from "services/storage";
import Slider from "react-slick";
import { useNavigate } from "react-router-dom";

// tipo 3 = imagem
const tipos = {
    "image": 3,
    "video": 1,
    "banner": 99,
}
const settingsSliderBanner = {
    arrows: false,
    dots: false,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
};

export default function Conteudo(props) {
    const innerProps = {...props, element: undefined, tag: undefined}
    const {tipo, element, children, isMobileSize, tag} = props;
     const navigate = useNavigate();

    const [componente, setComponente] = React.useState(element);
    const [mensagem, setMensagem] = React.useState('componente filho invalido');
    const [error, setError] = React.useState(undefined);

    const tipoId = tipos[tipo || 'image'] ?? 3;

    const [listConteudo, setListConteudo] = React.useState([{imagem: '', id: 0}]);
    const [listBanner, setListBanner] = React.useState([{caminhoMobile: '', caminho: '', id: 0}]); 

    if (tipo === undefined || element === undefined || tag === undefined) {
        setComponente('error');
        setMensagem('Conteudo, propriedades inválidas');
    }

    const navigateLink = (link) => {
        if (link == undefined)
            return;
        if (link.indexOf('/') === 0) {
            navigate(link);
        }
        else {
            window.location.href = link;
        }
    }

    React.useEffect(() => {
        const ObterBannes = async () => {
            const chaveCache = `banner-${tag}`;
            const cache = StorageGetItem(chaveCache);
            if (cache) {
                setListBanner(cache);
                console.log(`${chaveCache} from cache:`, cache);
                return;
            }
            try {
                const {data} = await api.get(`/banner/bannerPagina/ListarPorPagina?paginaId=${tag}`);
                if (data && data.length > 0) {
                    /*
                    "bannerId": 37,
                    "banner": {
                        "caminho": "https://zicard-accentiv.s3.us-east-1.amazonaws.com/farma-pontos/banner-1-alterado.jpg",
                        "caminhoMobile": "https://zicard-accentiv.s3.us-east-1.amazonaws.com/farma-pontos/banner-1-mobile.jpg",
                        "link": "/cadastro",
                        "ordem": 2
                    }
                    */
                    const lista = data.map(item => {return {id: item.bannerId, caminho: item.banner.caminho, caminhoMobile: item.banner.caminhoMobile, link: item.banner.link, ordem: item.banner.ordem}})
                    StorageSetItem(chaveCache, lista, 20 * 60);
                    setListBanner(lista);
                } else {
                    throw new Error('nenhum registro retornado');
                }
                
                
                
            } catch (error) {
                setError(error);
                console.log('error banners', error)
                setComponente('error')
                setMensagem(`ObterBannes error: ${error.message}`)
            }
        }

        const ObterVideos = async () => {
            const cache = StorageGetItem('#videos');
            if (cache) {
                setListConteudo(cache);
                console.log('#videos from cache:', cache);
                return;
            }

            try {
                const { data } = await api.get("/conteudo/listarAtivos");
                if (data && data.length > 0) {
                    const lista = data.map(item => {return {id: item.id, videoUrl: item.videoUrl, nome: item.nome, imagem: item.imagem, link: item.link}})
                    StorageSetItem('#videos', lista, 20 * 60);
                    setListConteudo(lista);
                } else {
                    throw new Error('nenhum registro retornado');
                }
                
            } catch (error) {
                setError(error);
                console.log('error videos', error)
                setComponente('error')
                setMensagem(`ObterVideos error: ${error.message}`)
            }

        }

        const ObterConteudo = async () => {
            const chaveCache = `conteudo-${tag}-${tipoId}`;
            const cache = StorageGetItem(chaveCache);
            if (cache) {
                setListConteudo(cache);
                console.log(`${chaveCache} from cache:`, cache);
                return;
            }

            const request = {
                "pagina": 1,
                "qtdItens": 1,
                "objeto": {
                    "ativo": true,
                    "tag": tag,
                    "tipoConteudoId": tipoId
                }
            }
            
            try {
                const {data} = await api.post('/conteudo/pesquisar', request);
                const {retorno} = data;
                if (retorno && retorno.length > 0) {
                    const lista = retorno.map(item => { return {id: item.id, imagem: item.imagem, texto: item.texto, nome: item.nome, link: item.link, videoUrl: item.videoUrl }})
                    StorageSetItem(chaveCache, lista, 20 * 60);
                    setListConteudo(lista);
                } else {
                    throw new Error('nenhum registro retornado');
                }
            } catch (error) {
                setError(error);
                console.log('error conteudo', error)
                setComponente('error')
                setMensagem(`ObterConteudo error: ${error.message}`)
            }
        } 

        if (tag && tipoId) {
            if (tag === '#videos')
                ObterVideos()
            else if (tipo === 'banner')
                ObterBannes()
            else 
                ObterConteudo()
        }
    }, []);

    if (componente === 'error') {
        return (<ErrorComponent mensagem={mensagem} tag={tag} element={element} tipo={tipo} tipoId={tipoId} error={error} />)
    } else if (tipo === 'banner') {
        if (componente === "Image") {
            return ( listBanner[0].caminho
            ? <Image src={listBanner[0].caminho} {...innerProps} />
            : <ErrorComponent mensagem={'Imagem not found'} tag={tag} element={element} tipo={tipo} tipoId={tipoId} error={listBanner} />
            )
        }
        else if (componente === "Children") {
            return (<>{children(listBanner)}</>)
        }
        else if (componente === "SlideBanner") {

            return listBanner.length > 0 ? (
            <Slider {...settingsSliderBanner} className="slider-container">
                { listBanner.map((item, index) => 
                    <Box key={index} data-link={item.link || 'null'} onClick={() => {navigateLink(item.link)}}>
                        <div className="container-slide" style={{ cursor: 'pointer' }}>
                            <div>
                                <Image
                                    src={isMobileSize ? item.caminhoMobile : item.caminho}
                                    style={{ width: '100%' }}
                                />
                            </div>
                        </div>
                    </Box>
                )}
            </Slider> ) : null;
            /*
            {bannersMiddle.length > 0 &&
                <Slider {...settings} className="slider-container">
                    {bannersMiddle?.length &&
                        bannersMiddle.map((item: any) => {
                            return (
                                <Box
                                    key={item.banner?.id}
                                    onClick={() => navigate('/cadastro')}
                                >
                                    <div className="container-slide" style={{ cursor: 'pointer' }}>
                                        <div>
                                            <Image
                                                src={isMobileSize ? item.banner?.caminhoMobile : item.banner?.caminho}
                                                style={{ width: '100%' }}
                                            />
                                        </div>
                                    </div>
                                </Box>
                            );
                        })}
                </Slider>
            }
            */
        }
        
    } else {
        if (componente === "Image") {
            return ( listConteudo[0].imagem
            ? <Image src={listConteudo[0].imagem} {...innerProps} />
            : <ErrorComponent mensagem={'Imagem not found'} tag={tag} element={element} tipo={tipo} tipoId={tipoId} error={listConteudo} />
            )
        }
        else if (componente === "SlideVideo") {
            return (listConteudo.length === 0 || listConteudo[0].id === 0 
                ? <ErrorComponent mensagem={'Videos not found'} tag={tag} element={element} tipo={tipo} tipoId={tipoId} error={listConteudo} />
                : <SlideVideo videos={listConteudo} />
            )
        }
        else if (componente === "Children") {
            return (<>{children(listConteudo)}</>)
        }

    }  
    
    return (<ErrorComponent mensagem={'component not found'} tag={tag} element={element} tipo={tipo} tipoId={tipoId} error={error} />)


}

const ErrorComponent = ({mensagem, tag, element, tipo, tipoId, error}) => {
    if (process.env.REACT_APP_TESTE === 'false') return (null);
    return (
        <div className='monitorCSS' style={{zIndex: 999999, minHeight: '100px'}}>{mensagem}: <br />{JSON.stringify({mensagem, tag, element, tipo, tipoId, error})}</div>
    )
}

